<app-header></app-header>

<div [ngStyle]="{ 'min-height': 'calc(100% - ' + headerHeight + 'px' }" class="bg-light-blue">

  <div *ngIf="!loading" class="container">
    <!-- Start Teachers Desktop -->
    <div class="flex-center-column">
      <mat-card class="margin-top-1 teacher-card d-flex">
        <div class="row">
          <div class="col-md-12 mb-4">
            <h1 class="teacher-name bold primary">
              {{ teacher.name }} {{ teacher.surname }}

              <mat-icon
                *ngIf="teacher.validated"
                svgIcon="validated"
                class="validated-icon ml-2"
                [matTooltip]="'validated-description' | translate"
                matTooltipPosition="above"
              >
              </mat-icon>
            </h1>
          </div>
 

          <div class="col-md-5">
            <!-- Start video -->
            <!-- START novideo -->
            <div *ngIf="!teacher.video_presentation" style="position: relative">
              <img src="assets/img/no-video-background.jpg" class="img-fluid" />
              <div class="centered text-center bold primary">
                {{ "teacher-dont-upload-video" | translate }}
              </div>
            </div>
            <!-- END novideo -->
            <span *ngIf="teacher.video_presentation">
              <div
                *ngIf="teacher.video_presentation != null"
                style="padding: 56.25% 0 0 0; position: relative"
              >
                <iframe
                  [src]="teacher.video_presentation | domSeguro"
                  frameborder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowfullscreen
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  "
                  title=""
                ></iframe>
              </div>
              <script src="https://player.vimeo.com/api/player.js"></script>
            </span>
            <!-- End video -->
          </div>

          <!-- Start columna datos -->
          <div class="col-md-7">
            <div class="row">
              <div class="col-md-12">
                <!-- Name & Country -->
                <div class="">
                  <!-- START Imagen profesor -->
                  <div class="float-left">
                    <div class="over-photo-teacher" *ngIf="teacher.is_premium">
                      <img
                        class="text-right"
                        src="../../../../assets/img/premium-crown.png"
                      />
                      <p>{{ "premium" | translate }}</p>
                    </div>
                    <!-- Photo -->
                    <img
                      [name]="teacher.photo_url"
                      class="photo-teacher margin-right-05 teacher-col-1"
                      appErrorImage
                      lazy-load
                    />
                  </div>
                  <!-- END Imagen profesor -->

                  <!-- START País del profesor-->
                  <div class="mt-2">
                    <span class="bold primary">{{ "country" | translate }}: </span>
                    <span class="margin-left-05">{{
                      teacher?.country?.name
                    }}</span>
                  </div>
                  <div>
                    <!-- START Also Speak -->
                    <div class="teacher-lessons">
                      <span
                        *ngFor="
                          let lesson of teacher.languages;
                          let last = last
                        "
                      >
                        {{ lesson?.name }}
                        <span class="language-level">{{ lesson.level }}</span>
                        <span *ngIf="!last">, </span>
                      </span>
                    </div>
                    <!-- END Also Speak -->
                  </div>
                  <!-- END País del profesor-->
                </div>

                <div class="pt-2">
                  <div>
                    <mat-star-rating
                      [rating]="teacher.score_average"
                      [starCount]="5"
                      [disabled]="true"
                      color="primary"
                    >
                    </mat-star-rating>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-3">
                <div class="row p-3 info-class-price">
                  <!-- START Caja materia precio -->
     
                    <div class="col-md-12 mt-3">
                      <span class="look-for-label"><i class="fas fa-info-circle"></i>{{ "watching-lesson" | translate }}:</span>
                      <div class="row ">
                        
                          <div class="col-md-6 p-2 my-auto">
                            <!-- START Current Study lesson -->
                            <div class=" bold">
                           <div *ngIf="currentSubject.name!=''">  {{ currentSubject.name }} </div> 
                            </div>
                            <!-- END Current Study lesson -->
                          </div>
                          <div class="col-md-6 p-2">
                            <!-- Start Precio -->
                            <div class="teacher-price">
                            
                                <span
                                  *ngIf="currency == 'eur' && teacher.price_hour_single"
                                  class="bold"
                                  >{{ teacher.price_hour_single }} €</span
                                >
                                <span
                                  *ngIf="
                                    currency == 'mxn' && teacher.price_hour_single_mxn
                                  "
                                  class="bold"
                                  >${{ teacher.price_hour_single_mxn }} MXN</span
                                >
                                <span
                                  *ngIf="
                                    currency == 'usd' && teacher.price_hour_single_usd
                                  "
                                  class="bold"
                                  >${{ teacher.price_hour_single_usd }} USD</span
                                >
                                /
                                <span
                                  *ngIf="
                                    !teacher.price_hour_single &&
                                    !teacher.price_hour_single_mxn &&
                                    !teacher.price_hour_single_usd
                                  "
                                  >-</span
                                >
                                <span >{{
                                  "per-hour" | translate
                                }}</span>
                          
                            </div>
                            <!-- End Precio -->
                          </div>            
                      </div>
                    </div>
                  <!-- END Caja materia precio -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-4 mb-4">
            <!-- Start descripcion -->
            <div class="primary bold"><i class="fas fa-plus"></i> {{ "presentation" | translate }}</div>
            <div class="p-3 teacher-info-box">
              {{ teacher.description }}
            </div>
            <!-- End descripcion -->
        </div>
        <div class="col-md-12 border-bottom pb-4 mb-3">
          
    <!-- START Otras materias del profesor -->
    
          <div class="primary bold"><i class="fas fa-plus"></i> {{ "other-subjects-teacher" | translate }} </div>
          <div class="row margin-top-1">
            <div class="col-md-4">
              <div class="bold">{{ "languages" | translate }}</div>
              <div *ngFor="let lang of teacher.languagelessons">
                <i class="far fa-bookmark"></i> {{ lang.lesson.name }}
              </div>
            </div>
            <div class="col-md-4">
              <div class="bold">{{ "schoolar-subjects" | translate }}</div>
              <div *ngFor="let lesson of teacher.subjectlessons">
                <i class="far fa-bookmark"></i> {{ lesson.lesson.name }}
              </div>
            </div>
            <div class="col-md-4">
              <div class="bold">{{ "other-activities" | translate }}</div>
              <div *ngFor="let custom of teacher.custom_lessons">
                <i class="far fa-bookmark"></i> {{ custom.lesson.name }}
              </div>
            </div>
          </div>

    <!-- END Otras materias del profesor -->
        </div>
        <div class="col-md-6">
          <button
          type="button"
          color="primary"
          class="contact-btn blue-button mr-2 mt-2"
          (click)="onSendMessage(teacher)"
        >
          <i class="far fa-comment-dots"></i>
          {{ "contact" | translate }}
        </button>
        </div>
        <div class="col-md-6"> <a class="btn btn-secondary float-right" [routerLink]="['/search/teacher']"
          ><i class="far fa-arrow-alt-circle-left"></i> {{ "back" | translate }}</a
        ></div>

          <!-- End columna datos -->
        </div>
   
      </mat-card>
    </div>
    <!-- End Teachers Desktop -->


    <!-- START Calendario -->

    <div class="container teacher-container" *ngIf="isStudent">
      <div class="side margin-top-2">
        <div class="sticky-container bg-white mat-elevation-z2">
          <div class="mat-h1 bold primary mb-4">
            <i class="fas fa-school"></i>
            {{ "select-hours-to-booking" | translate }} <span class="primary">{{ currentSubject.name }} </span> con {{ teacher.name }} 
          </div>
          <div class="row p-3 info-class-price">
            <p>
              {{ "select-available-hours-of" | translate }}  {{ teacher.name }}.
            </p>
            <p>
              {{ "reservation-instructions-1" | translate }}  
            </p>
            <p>{{ "reservation-instructions-2" | translate }} </p>
          </div>
          <div class="row mt-4">
            <div class="col-md-6">              
                  <div class="mat-h3">
                    <span class="primary bold">{{ "hours-left" | translate }}:</span>
                    <span> {{ hoursLeft }}</span> {{ "hours" | translate }}.
                  </div>
            </div>

            <div class="col-md-6"> 
                  <div class="float-right">
                    <button
                      *ngIf="!ios"
                      mat-raised-button
                      color="primary"
                      class="width-50 margin-top-05 padding-05 gradient-button"
                      type="button"
                      (click)="showPaymentDialog()"
                    >
                      <mat-icon class="margin-right-05">shopping_cart</mat-icon>
                      <span>{{ "add-hours" | translate }}</span>
                    </button>

                    <button
                      *ngIf="ios"
                      mat-raised-button
                      color="primary"
                      class="width-50 margin-top-05 padding-05 gradient-button"
                      type="button"
                      (click)="openWordiix()"
                    >
                      <mat-icon class="margin-right-05">shopping_cart</mat-icon>
                      <span>{{ "add-hours-web" | translate }}</span>
                    </button>

                    
                  </div>              
            </div>
          </div>

          <div *ngIf="isStudent">
            <!-- Lesson and Level -->
            <form [formGroup]="form" class="padding-top-1 row">

              <!-- <mat-form-field
                appearance="outline"
                class="margin-top-1 col-6 margin-auto padding-0"
              >
                <mat-label>{{ "subject" | translate }}</mat-label>
                <mat-select
                  formControlName="lesson"
                  (selectionChange)="onChangeLessonValue($event)"
                >
                  <mat-option
                    *ngFor="let lesson of lessonOptions"
                    [value]="lesson"
                  >
                    {{ lesson.name }} -
                    <span class="mat-caption">{{
                      lesson.type | translate
                    }}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field> -->

              <!-- <mat-form-field
                appearance="outline"
                class="margin-top-1 col-6"
                *ngIf="levelOptions.length"
              >
                <mat-label>{{ "level" | translate }}</mat-label>
                <mat-select formControlName="level">
                  <mat-option
                    *ngFor="let level of levelOptions"
                    [value]="level"
                  >
                    {{ level.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field> -->
            </form>

            <div
              class="row justify-content-around"
              *ngIf="!canFreeBook; else FreeBookTemplate"
            >
              <button
                mat-raised-button
                color="primary"
                class="width-50 margin-top-1 margin-bottom-05 padding-05 col-6"
                [disabled]="isDisabled"
                type="button"
                (click)="createBookings()"
              >
                <mat-icon class="margin-right-05">event_available</mat-icon>
                <span>{{ "booking" | translate }}</span>
              </button>
              <span
                *ngIf="hoursLeft == 0"
                class="text-danger col-12 text-center cursor-pointer"
                (click)="showPaymentDialog()"
                ><u>{{ "add-hours" | translate }}</u></span
              >
            </div>

            <ng-template #FreeBookTemplate>
              <div class="margin-top-05">
                {{ "have-1-free-book" | translate }}
              </div>
              <div class="row justify-start">
                <button
                  mat-raised-button
                  color="primary"
                  class="width-50 margin-top-1 margin-bottom-2 padding-05 col-5"
                  [disabled]="isDisabled"
                  type="button"
                  (click)="createFreeBookings()"
                >
                  <mat-icon class="margin-right-05">event_available</mat-icon>
                  <span>{{ "booking" | translate }}</span>
                </button>
              </div>
            </ng-template>
          </div>

          <!-- Availability -->
          <div class="margin-top-1 calendar-view">
            <app-booking-calendar
              (viewRange)="onChangeView($event)"
              [schedule]="schedule"
              (onEventClicked)="onEventClicked($event)"
            ></app-booking-calendar>
          </div>
        </div>
      </div>
    </div>

  </div>

  <app-loading [loading]="loading || loading2"></app-loading> 
  <app-footer></app-footer>

</div>
